export default __webpack_public_path__ + "static/media/polk_p_rare.048e58c3.png";